import { FaPhone, FaUserTie, FaCheck, FaMapMarkerAlt, FaRoad, FaStar } from 'react-icons/fa';

const process = [
    {
        id: 1,
        icon: <FaPhone />, // Booking Icon
        title: 'Booking',
        content: 'Book your ride through our easy-to-use app or website, providing your pickup and drop-off details.',
    },
    {
        id: 2,
        icon: <FaUserTie />, // Driver Assignment Icon
        title: 'Driver Assignment',
        content: 'A nearby driver is assigned to your ride, ensuring quick and reliable service at your location.',
    },
    {
        id: 3,
        icon: <FaCheck />, // Ride Confirmation Icon
        title: 'Ride Confirmation',
        content: 'You receive a confirmation with driver details, so you know exactly who will be picking you up.',
    },
    {
        id: 4,
        icon: <FaMapMarkerAlt />, // Pickup Icon
        title: 'Pickup',
        content: 'Your driver arrives at the scheduled time, ready to transport you to your destination safely and comfortably.',
    },
    {
        id: 5,
        icon: <FaRoad />, // Journey Icon
        title: 'Journey',
        content: 'Enjoy a smooth ride with our professional driver, who ensures you reach your destination on time.',
    },
    {
        id: 6,
        icon: <FaStar />, // Drop-off & Feedback Icon
        title: 'Drop-off & Feedback',
        content: 'After arriving at your destination, you can rate your experience and provide feedback.',
    },
];

export default process;